import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';
import { InsuranceTypesEnum, tInsuranceTypeEnum } from '@models/InsuranceType';
import { PaymentMethods } from '@models/PaymentInfo';
import { selectHealthPolicyClaim } from './selector';
import { FormValues, formValuesSchema } from './schema';

export const useInitialValues = () => {
  const { policy, insurancePolicyUser } = useSelector(selectHealthPolicyClaim);
  const initialValues: FormValues = formValuesSchema.getDefault() as unknown as FormValues;

  return useMemo(() => {
    merge(initialValues, {
      coveredByOtherInsurance: '',
      totalClaimedAmount: '',
      policyHolder: insurancePolicyUser?.user?.name ?? '',
      policyHolderDob: insurancePolicyUser?.user?.dob ?? '',
      policyHolderGender: insurancePolicyUser?.user?.gender ?? '',
      policyNumber: policy?.policyNumber ?? '',
      policyPlanType: `${tInsuranceTypeEnum((policy?.insuranceType as InsuranceTypesEnum) ?? '')} - ${insurancePolicyUser?.benefitTemplate.name ?? ''}`,
      policyExpiryDate: insurancePolicyUser?.expirationDate ?? '',
      mobileNumber: insurancePolicyUser?.user?.mobileNumber ?? '',
      email: insurancePolicyUser?.user?.email ?? '',
      paymentInfo: {
        beneficiaryName: insurancePolicyUser?.user?.name ?? '',
        paymentMethod: PaymentMethods.BankTransfer,
      },
    });

    return initialValues;
  }, [policy, insurancePolicyUser]);
};
